"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-loading-spinner.tsx
var LoadingSpinner = function LoadingSpinner(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M12.0012 24C10.3815 24 8.80867 23.6836 7.32962 23.0578C5.8998 22.4531 4.61764 21.5859 3.51597 20.4844C2.4143 19.3828 1.54703 18.1008 0.94228 16.6711C0.316437 15.1922 0 13.6195 0 12C0 11.5336 0.377381 11.1562 0.843832 11.1562C1.31028 11.1562 1.68766 11.5336 1.68766 12C1.68766 13.3922 1.95957 14.7422 2.49868 16.0148C3.01904 17.243 3.76209 18.3469 4.70905 19.2938C5.65602 20.2406 6.76003 20.9859 7.98828 21.5039C9.25872 22.0406 10.6088 22.3125 12.0012 22.3125C13.3935 22.3125 14.7436 22.0406 16.0164 21.5016C17.2447 20.9813 18.3487 20.2383 19.2956 19.2914C20.2426 18.3445 20.988 17.2406 21.506 16.0125C22.0428 14.7422 22.3147 13.3922 22.3147 12C22.3147 10.6078 22.0428 9.25781 21.5037 7.98516C20.9851 6.75998 20.2345 5.64659 19.2933 4.70625C18.3539 3.76387 17.2401 3.01321 16.0141 2.49609C14.7436 1.95938 13.3935 1.6875 12.0012 1.6875C11.5347 1.6875 11.1573 1.31016 11.1573 0.84375C11.1573 0.377344 11.5347 0 12.0012 0C13.6209 0 15.1937 0.316406 16.6727 0.942188C18.1025 1.54688 19.3847 2.41406 20.4864 3.51562C21.588 4.61719 22.453 5.90156 23.0577 7.32891C23.6836 8.80781 24 10.3805 24 12C24 13.6195 23.6836 15.1922 23.0577 16.6711C22.4553 18.1008 21.588 19.3828 20.4864 20.4844C19.3847 21.5859 18.1002 22.4508 16.6727 23.0555C15.1937 23.6836 13.6209 24 12.0012 24Z",
    fill: "currentColor"
  }));
};

var _default = LoadingSpinner;
exports.default = _default;